import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MenusNewComponent } from './menus-new.component';

const routes: Routes = [ { path: '', component: MenusNewComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MenusNewRoutingModule { }
